import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import {RulesService} from '../rules.service';
import {Observable} from 'rxjs/Observable';
import {SpinnerService} from '../../core/spinner/spinner.service';

@Injectable()
export class RuleResolverService implements Resolve<any>{
   page = 1 ; pageSize = 10;
  constructor(private ruleService: RulesService,
              private spinner: SpinnerService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    this.spinner.show();
    return this.ruleService.getRuleList(this.page, this.pageSize)
      .map(res => { this.spinner.hide(); return res; } );
  }
}



// WEBPACK FOOTER //
// ./src/app/rules/resolver/rule-resolver.service.ts